var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-text_1_",
    "data-name": "file-text (1)",
    transform: "translate(0 -0.418)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7097",
    "data-name": "Rectangle 7097",
    width: 18,
    height: 18,
    transform: "translate(0 0.418)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65019",
    "data-name": "Path 65019",
    d: "M58.776,45.612H48.567A.567.567,0,0,1,48,45.044V32.567A.567.567,0,0,1,48.567,32h6.806l3.97,3.97v9.074A.567.567,0,0,1,58.776,45.612Z",
    transform: "translate(-44.597 -29.563)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65020",
    "data-name": "Path 65020",
    d: "M152,32v3.97h3.97",
    transform: "translate(-141.224 -29.563)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278",
    "data-name": "Line 278",
    x2: 6,
    transform: "translate(6 9.418)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_279",
    "data-name": "Line 279",
    x2: 6,
    transform: "translate(6 12.418)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.7d9371d4f4bd2e6b179d8547bb4c73c0.svg";
export { ForwardRef as ReactComponent };